import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';

// -----------------------------------------------------------
// DataWorld logo — the real brand mark from the Flutter app
// (assets/branding/dataworld_logo_rounded.png). The badge already
// includes its own rounded indigo background, so no extra framing.
// `sx` accepts MUI sx props (mostly width/height).
// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const img = (
    <Box
      component="img"
      src="/dataworld_logo.png"
      alt="DataWorld"
      sx={{ width: 40, height: 40, objectFit: 'contain', display: 'block', ...sx }}
    />
  );

  if (disabledLink) return img;
  return <RouterLink to="/">{img}</RouterLink>;
}
